/**
 * Created by Administrador on 20/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('notificationService', notificationService)

    notificationService.$inject = ['$http', 'CONFIG', 'messageService'];

    function notificationService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CARGO_CONTROL + '/' + CONFIG.API + '/notifications';
        var service = {
            getNotifications: getNotifications,
            getNotificationList: getNotificationList,
            getNotification: getNotification,
            saveNotification: saveNotification,
            updateNotification: updateNotification,
            deleteNotification: deleteNotification
        }

        return service;

        function getNotifications(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getNotificationList(){
            return $http.get(urlBase + '/list')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getNotification(id){
            return $http.get(urlBase + "/" + id )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('notifications')
                });
        }

        function saveNotification(notification){
            return $http.post(urlBase, notification)
                .then(function(response){
                    messageService.register('notifications');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('notifications')
                });
        }

        function updateNotification(notificationId, notification){
            return $http.put(urlBase + "/" + notificationId, notification)
                .then(function(response){
                    messageService.registerUpdate('notifications')
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('notifications')
                });
        }

        function deleteNotification(notificationId){
            return $http.delete(urlBase + "/" + notificationId)
                .then(function(response){
                    messageService.registerDelete('notifications');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('notifications');
                });
        }
    }
})();
